import { useEffect, useState } from "react";

const isDropzOpsUser = localStorage.getItem("isDropzOpsUser");

const featureFlags = {
	expertHelp: false,
	oneClickApply: false,
	dsp: isDropzOpsUser || false,
	featureToggle: isDropzOpsUser || false,
};

export function useFeatureFlag(flagName) {
	const [isEnabled, setIsEnabled] = useState(false);

	useEffect(() => {
		setIsEnabled(!!featureFlags[flagName]);
	}, [flagName]);

	// eslint-disable-next-line no-undef
	return process.env.NODE_ENV === "development" ? true : isEnabled;
}
